import { DynamicallyFilteredLeadsQuery, ProfileLeadMutation } from 'graphql/bindings/AdminBindings'
import { SpinnerButton, useSnackbar } from '@forgeglobal/design-framework'
import Modal, { useModal } from './Modal'
import React, { useState } from 'react'

export const useProfileModal = () => {
  const { isOpen, open, close } = useModal()
  const [accountId, setAccountId] = useState<string | null>(null)

  return {
    accountId,
    isOpen,
    open: (newAccountId: string) => {
      setAccountId(newAccountId)
      open()
    },
    close: () => {
      setAccountId(null)
      close()
    },
  }
}

interface ProfileModalProps {
  open: boolean
  onClose: () => void
  profileLead: (accountId: string, qualified: boolean) => Promise<ProfileLeadMutation['profileLead'] | undefined>
  account: DynamicallyFilteredLeadsQuery['dynamicQuery']['data'][0] | undefined
}

const ProfileModal: React.FC<ProfileModalProps> = ({ open, onClose, account, profileLead }) => {
  const { enqueueSnackbar } = useSnackbar()

  const handleClick = (qualified: boolean) => {
    onClose()

    const accountId = account?.id

    if (accountId) {
      profileLead(accountId, qualified).catch(() => {})
    } else {
      enqueueSnackbar("We couldn't find that account. Please try again.", { variant: 'error' })
    }
  }

  return (
    <Modal open={open} title="Profile account" onClose={onClose}>
      <SpinnerButton
        fullWidth
        color="primary"
        loading={false}
        caption="Unqualified"
        onClick={() => handleClick(false)}
      />
      <SpinnerButton fullWidth color="primary" loading={false} caption="Qualified" onClick={() => handleClick(true)} />
    </Modal>
  )
}

export default ProfileModal
